'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/11/1.
                    */

// import SubmitBtn from '../SubmitBtn/SubmitBtn';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupBuyingOrderDetailComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GroupBuyingOrderDetailComponent, _Component);

  function GroupBuyingOrderDetailComponent() {
    (0, _classCallCheck3.default)(this, GroupBuyingOrderDetailComponent);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(GroupBuyingOrderDetailComponent).call(this));
  }

  (0, _createClass3.default)(GroupBuyingOrderDetailComponent, [{
    key: 'onCancelOrder',
    value: function onCancelOrder(orderId) {
      var cancelOrder = this.props.cancelOrder;

      if (cancelOrder) {
        cancelOrder(orderId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./GroupBuyingOrderDetailComponent.scss');
      var orderDetail = this.props.orderDetail;

      var returnDiv = _react2.default.createElement('div', null);
      if (orderDetail instanceof Array && orderDetail.length > 0) {
        (function () {
          var detail = orderDetail[0];
          returnDiv = _react2.default.createElement(
            'div',
            { className: styles.component },
            _react2.default.createElement(
              'div',
              { className: styles.content },
              _react2.default.createElement(
                'div',
                { className: styles.header },
                '订单编号：',
                detail.orderId,
                _react2.default.createElement(
                  'div',
                  { className: styles.orderStatus },
                  detail.orderStatus
                )
              ),
              _react2.default.createElement('div', { className: styles.wholeLine }),
              _react2.default.createElement('div', { className: styles.leftLine }),
              _react2.default.createElement('div', { className: styles.rightLine }),
              _react2.default.createElement('div', { className: 'clear' }),
              _react2.default.createElement(
                'div',
                { className: styles.header,
                  style: { paddingTop: '8px', paddingRight: '10px', float: 'right' } },
                detail.orderDate
              ),
              _react2.default.createElement('div', { className: 'clear' }),
              _react2.default.createElement(
                'div',
                { className: styles.contentSection },
                _react2.default.createElement(
                  'div',
                  { className: styles.pageTopTitle },
                  '艺品信息'
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.item },
                  '艺品：',
                  detail.productName
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.item },
                  '数量：',
                  detail.number
                )
              ),
              _react2.default.createElement('div', { className: 'clear' }),
              _react2.default.createElement(
                'div',
                { className: styles.contentSection },
                _react2.default.createElement(
                  'div',
                  { className: styles.pageTopTitle },
                  '团购信息'
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.item },
                  '团购方案：',
                  detail.groupBuyingPlan
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.item },
                  '方案描述：',
                  detail.planDescribe
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.item },
                  '艺品总数：',
                  detail.totalNumber
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.item },
                  '截止日期：',
                  detail.endDate
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.item },
                  '剩余数量：',
                  detail.numberRemaining
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.item },
                  '当前价格：',
                  detail.currentPrice
                )
              ),
              _react2.default.createElement('div', { className: 'clear' }),
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/groupbuyingorderlist', className: styles.bottomBtn },
                '退出查询'
              ),
              detail.orderStatus === '团购中' ? _react2.default.createElement(
                'span',
                { style: { marginRight: 20 }, onClick: function onClick() {
                    return _this2.onCancelOrder(detail.orderId);
                  },
                  className: styles.bottomBtn },
                '取消团购'
              ) : '',
              detail.orderStatus === '未结算' ? _react2.default.createElement(
                _reactRouter.Link,
                { style: { marginRight: 20 },
                  to: '/orderwriting/' + detail.orderWritingNumber,
                  className: styles.bottomBtn },
                '去结算'
              ) : '',
              detail.orderStatus === '已结算' ? _react2.default.createElement(
                _reactRouter.Link,
                { style: { marginRight: 20 },
                  to: '/orderdetail/' + detail.normalOrderNumber,
                  className: styles.bottomBtn },
                '查询订单'
              ) : '',
              _react2.default.createElement('div', { className: 'clear' })
            )
          );
        })();
      }
      return returnDiv;
    }
  }]);
  return GroupBuyingOrderDetailComponent;
}(_react.Component), _class.propTypes = {
  orderDetail: _react.PropTypes.array,
  cancelOrder: _react.PropTypes.func
}, _temp);
exports.default = GroupBuyingOrderDetailComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GroupBuyingOrderDetailComponent/GroupBuyingOrderDetailComponent.js
 ** module id = 1351
 ** module chunks = 0
 **/